
import {initWebComponent} from "@/helpers/web-component-helper";
import {changeLanguage, getActiveLanguage, updateLanguage} from "@/modules/language/language";

export class HeaderLanguageComponent extends HTMLElement {
    constructor(){
        super();

        let key = this.getAttribute('data-key')
        const name = this.getAttribute('data-name')
        const tooltip = this.getAttribute('data-tooltip')

        let activeClass = 'far'
        if(key === 'nl') {
            activeClass = 'fa'
        } else {
            key = 'gb'
        }

        const template = document.createElement('template');

        let languages = [{
            key: 'en',
            icon: 'gb',
            title: 'Nederlands'
        }, {
            key: 'nl',
            icon: 'nl',
            title: 'English'
        }]

        template.innerHTML = getInnerHtml(languages);

        initWebComponent(this, template)

        this.addEventListener('click', (event) => {

            //// console.log('click')

            // this.querySelector('.dropdown-menu-language').classList.toggle('show')

            const target = event.target.closest('header-button')
            const activeLanguage = getActiveLanguage()
            const key = target.dataset.key

            //// console.log(key)
            //// console.log(activeLanguage)
            if(key !== activeLanguage) {
                changeLanguage(key)

                this.innerHTML = getInnerHtml(languages.reverse())

                updateLanguage()
            }
        });

        function getInnerHtml(languages) {
            let innerHTML = ''
            languages.map((language, key) => {
                 if(key === 0) {
                     innerHTML += `
                        <header-button 
                            data-tooltip="${tooltip}"
                            data-icon="fi fi-` + language.icon + `"
                            data-title=""
                            data-tooltip=""
                            data-key="` + language.key + `">
                        </header-button>
                        <div class="dropdown-menu dropdown-menu-language dropdown-menu-right" style="margin-right: 240px;">`
                 } else {
                     innerHTML += `
                         <header-button
                         data-tooltip="${tooltip}"
                             data-icon="fi fi-` + language.icon + ` mr-2"
                             data-title="` + language.title + `"
                             data-tooltip=""
                             data-key="` + language.key + `">
                         </header-button>`
                 }
            })
            innerHTML += `</div>`
            return innerHTML
        }
    }

}

